import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { INotification } from 'core/types';

interface IState {
  notification: INotification;
}

const initialState: IState = {
  notification: null,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotification: (state, action: PayloadAction<INotification>) => {
      state.notification = action.payload;
    },
  },
});

export const { setNotification } = notificationsSlice.actions;

export const notificationsReducer = notificationsSlice.reducer;
